import { useEffect } from "react";
import "./InativarModal.css";

export default function InativarModal({ open, titulo, onClose, onConfirmar }) {
  if (!open) return null;

  // trava o scroll do body enquanto aberto
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  // Esc fecha, Enter confirma
  const handleKeyDown = (e) => {
    if (e.key === "Escape") onClose?.();
    if (e.key === "Enter") onConfirmar?.();
  };

  return (
    <div className="inavmd-bg" onKeyDown={handleKeyDown}>
      <div className="inavmd-box" role="dialog" aria-modal="true" aria-label="Inativar registro">
        <header className="inavmd-head">
          <h3 className="inavmd-title">Inativar</h3>
          <button className="inavmd-x" onClick={onClose} type="button" aria-label="Fechar">×</button>
        </header>

        <div className="inavmd-body">
          Deseja <strong>inativar</strong> “{titulo || "este item"}”?
        </div>

        <footer className="inavmd-foot">
          <button className="inavmd-btn" type="button" onClick={onClose}>Cancelar</button>
          <button className="inavmd-btn inavmd-btn-warn" type="button" onClick={onConfirmar}>Inativar</button>
        </footer>
      </div>
    </div>
  );
}
